/**
 * The Buckets page's form state (TRA-1705): the two fields and how they map
 * to the API's lists. Kept apart from the component so the page file
 * exports components only.
 */

import type { TeamBucketsResponse } from '@/api/generated/model'

export interface BucketsEdit {
  dataBuckets: string
  traceBucket: string
}

/** The saved buckets as the two fields show them. */
export function fieldsOf(saved: TeamBucketsResponse): BucketsEdit {
  return { dataBuckets: saved.data_buckets.join(', '), traceBucket: saved.trace_bucket ?? '' }
}

/** The comma-separated field as the list the API takes: trimmed, empties dropped. */
export function parseBuckets(text: string): string[] {
  return text
    .split(',')
    .map((entry) => entry.trim())
    .filter((entry) => entry !== '')
}
